import { useEffect, useState } from "react";
import { Box, CardContent, Typography } from "@mui/material";

import { useMapState } from "contexts/MapStateContext";
import { ControlWidget } from "../UiComponents";
import { managedFetch } from "utils/FetchManager";

const fetchLegend = async (url) => {
  const response = await managedFetch(url);
  const data = await response.json();
  try {
    return data.layers[0].legend;
  } catch (error) {
    console.error("Error fetching legend:", error, data);
    return null;
  }
};

const LegendItem = ({ imageData, label }) => (
  <Box display="flex" alignItems="center" mb={-0.25}>
    <img
      src={`data:image/png;base64,${imageData}`}
      alt={label}
      width={10}
      height={10}
      style={{ marginRight: 4 }}
    />
    <Typography variant="caption">{label}</Typography>
  </Box>
);

const Legend = ({ url, visible }) => {
  const [legendItems, setLegendItems] = useState([]);

  useEffect(() => {
    const loadLegend = async () => {
      const legend = await fetchLegend(url);
      if (!legend) return;
      setLegendItems(legend);
    };
    loadLegend();
  }, [url]);

  return (
    <ControlWidget
      sx={{
        bottom: "0",
        left: "0",
        maxWidth: "240px",
        maxHeight: "75vh",
        overflowY: "auto",
        paddingBottom: 0,
        zIndex: "3 !important",
        display: visible ? "block" : "none",
      }}
    >
      <CardContent>
        {legendItems.map((item, index) => (
          <LegendItem
            key={index}
            imageData={item.imageData}
            label={item.label}
          />
        ))}
      </CardContent>
    </ControlWidget>
  );
};

export default function Legends() {
  const { basemap } = useMapState();

  return (
    <Box>
      <Legend
        id="landfire-legend"
        visible={basemap === "landfire240" || basemap === "landfire230"}
        url="https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF2024/LF2024_FBFM40_CONUS/ImageServer/legend?f=pjson"
      />
      <Legend
        id="cpad-legend"
        visible={basemap === "cpad"}
        url="https://gis.cnra.ca.gov/arcgis/rest/services/Boundaries/CPAD_AgencyLevel/MapServer/legend?f=pjson"
      />
      <Legend
        id="landfire-dist-legend"
        visible={basemap === "landfire_dist"}
        url="https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF2024/LF2024_FDist_CONUS/ImageServer/legend?f=pjson"
      />
      <Legend
        id="landfire-annual-legend"
        visible={basemap.indexOf("landfire_dist_20") === 0}
        url="https://lfps.usgs.gov/arcgis/rest/services/Landfire_Disturbance/LF2022_Dist21_CONUS/ImageServer/legend?f=pjson"
      />
      <Legend
        id="sdi-legend"
        visible={basemap === "sdi"}
        url="https://imagery.geoplatform.gov/iipp/rest/services/Fire_Aviation/USFS_EDW_SAB_WildfireSuppressionDifficultyIndex97thPerc/ImageServer/legend?f=pjson"
      />
    </Box>
  );
}
